"use client";
import { jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from "react";
import { Drawer } from "../../Drawer/index.js";
import { OverlayTitle } from "../../OverlaySearchHeader/index.js";
import { Calendar } from "../Calendar/Calendar.js";
function DatePickerMobileComponent({ mode = 'single', handleCalendarChange, components, open = false, handleDrawerState, heading = 'Choose Dates', popOverText, selected, footer, subHeading, autoFocus, ...restProps }) {
    const handleClose = useCallback(()=>{
        handleDrawerState(false);
    }, [
        handleDrawerState
    ]);
    const stickyFooter = useMemo(()=>!!footer, [
        footer
    ]);
    const headingCustomNode = useMemo(()=>/*#__PURE__*/ jsx(OverlayTitle, {
            heading: heading,
            subHeading: subHeading,
            handleClose: handleClose,
            popOverText: popOverText,
            slots: {
                container: 'px-4 pb-4'
            }
        }), [
        heading,
        subHeading,
        popOverText,
        handleClose
    ]);
    return /*#__PURE__*/ jsx(Drawer, {
        title: "Calendar",
        showCloseButton: false,
        showDragHandle: false,
        open: open,
        description: "Overlay Calendar",
        direction: "bottom",
        scroll: "body",
        footer: footer,
        stickyFooter: stickyFooter,
        headingCustomNode: headingCustomNode,
        children: /*#__PURE__*/ jsx("div", {
            className: "relative flex w-full p-4",
            children: /*#__PURE__*/ jsx(Calendar, {
                ...restProps,
                autoFocus: autoFocus,
                mode: mode,
                handleCalendarChange: handleCalendarChange,
                components: components,
                selected: selected,
                scrollToSelectedMonthOnOpen: open && !!autoFocus
            })
        })
    });
}
const DatePickerMobile = /*#__PURE__*/ memo(DatePickerMobileComponent);
export { DatePickerMobile };
